package com.mps.asc_app.domain.slots

import com.mps.asc_app.data.config.TimeslotConfig

data class TimeSlot(val start: String, val end: String)

fun buildTimeSlots(cfg: TimeslotConfig): List<TimeSlot> {
    val startMin = parseHm(cfg.start)
    val endMin = parseHm(cfg.end)
    val step = cfg.intervalMinutes.coerceAtLeast(1)

    if(endMin <= startMin) return emptyList()

    val out = ArrayList<TimeSlot>()
    var t = startMin
    while (t <= endMin) {
        out.add(TimeSlot(start = formatHm(t), end = formatHm(t + step)))
        t += step
    }
    return out
}

private fun parseHm(value: String): Int {
    val parts = value.trim().split(":")
    if (parts.size != 2) return 0
    val h = parts[0].toIntOrNull() ?: 0
    val m = parts[1].toIntOrNull() ?: 0
    return (h.coerceIn(0, 23) * 60) + m.coerceIn(0, 59)
}

private fun formatHm(totalMinutes: Int): String {
    val h = (totalMinutes / 60).coerceIn(0, 23)
    val m = (totalMinutes % 60).coerceIn(0, 59)

    val hh = if (h < 10) "0$h" else h.toString()
    val mm = if (m < 10) "0$m" else m.toString()
    return "$hh:$mm"
}